import { useEffect, useLayoutEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import BlockUi from '../blockUi/BlockUi';
import withPageErrorHandler from '../higherOrderComponents/WithPageErrorHandler';
import { getUserDetail } from '../../actions/claud';
import { getWatchList } from '../../actions/watchList';
import { isBeforeTnCPathname } from '../../constants/routes';
import TerritoryMapModal from '../global/fullPageModal/TerritoryMapModal';
import { resetSelectedClAppAccountUserGuid } from '../../actions/linkedAccounts';

export const CruxPageLayout = ({
    header, children, footer,
    isHomePage, isCopyDisabled, history, permission
}) => {
    const store = useSelector(({ clapi, launchDarkly, claud, linkedAccounts }) => ({
        isFeatureFlagInitialized: launchDarkly.get('isFeatureFlagInitialized'),
        featureFlags: launchDarkly.get('featureFlag'),
        usrDetail: clapi.get('usrDetail'),
        claudUser: claud.get('user'),
        selectedClAppAccountUserGuid: linkedAccounts.get('selectedClAppAccountUserGuid'),
        listedAccount: linkedAccounts.get('listedAccount'),
    }), shallowEqual);
    const dispatch = useDispatch();

    const initCompleted = !!store.usrDetail && !!store.isFeatureFlagInitialized;
    const handleAppAccountUserGuidMismatch = () => {
        const isSelectedGuidInAccountList = store.listedAccount
            ?.some(account => account.clAppAccountUserGuid === store.selectedClAppAccountUserGuid);
        if (store.selectedClAppAccountUserGuid && isSelectedGuidInAccountList === false) {
            dispatch(resetSelectedClAppAccountUserGuid());
            window.location.reload();
        }
    }

    useEffect(() => {
        console.log("Crux/Init -> CruxPageLayout --> UseEffect");

        handleAppAccountUserGuidMismatch();

        if (store.selectedClAppAccountUserGuid && !store.claudUser) { // handles opening in a new tab
            dispatch(getUserDetail(store.selectedClAppAccountUserGuid));
        }
    }, [history.location.pathname, store.listedAccount]);

    useEffect(() => {
        // Making sure usrDetail and featureFlags are already initialized
        // because watchlist depends on both of these properties
        if (store.usrDetail && store.featureFlags) {
            dispatch(getWatchList());
        }
    }, [store.usrDetail, store.featureFlags])

    useLayoutEffect(() => {
        // ON MOUNT
        const keyDownCallback = (e) => {
            // CTRL Key is for windows only particularly on Edge Browser
            // FF, CHROME, SAFARI, and Chromium Edge is working fine
            if (e.ctrlKey) { // "ctrl" key
                if ([67, 88].includes(e.keyCode)) { // "c|x" key
                    e.preventDefault();
                    return false;
                }
            }
            return true;
        };
        if (isCopyDisabled) {
            document.body.addEventListener('keydown', keyDownCallback);
        }
        // UNMOUNTING
        return () => {
            if (isCopyDisabled) {
                document.body.removeEventListener('keydown', keyDownCallback);
            }
        };
    }, [isCopyDisabled]);

    //
    // CruxPageLayout execution logic start:
    //

    if (!isBeforeTnCPathname() && !initCompleted) {
        return (<BlockUi
            blocking
            backdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' }}}
        />);
    }

    if (permission && !permission.hasAccess({
        userDetails: store.usrDetail,
        location: history.location,
        history,
        featureFlags: store.featureFlags,
    })) {
        return (<BlockUi blocking backdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.3);' }}} />);
    }

    return (
        <div
            id="crux-layout"
            className={isHomePage && 'is-home-page'}
            onContextMenu={isCopyDisabled ? (e => e.preventDefault()) : undefined}
            onCopy={isCopyDisabled ? (e => e.preventDefault()): undefined}
            onCut={isCopyDisabled ? (e => e.preventDefault()): undefined}
        >
            {header}
            <div className="wrapper">
                <TerritoryMapModal>
                    {children}
                </TerritoryMapModal>
                {footer}
            </div>
        </div>
    );
};

CruxPageLayout.propTypes = {
    children: PropTypes.element,
    header: PropTypes.element,
    footer: PropTypes.element,
    isHomePage: PropTypes.bool,
    isCopyDisabled: PropTypes.bool,
    selectedClAppAccountUserGuid: PropTypes.string,
    listedAccount: PropTypes.array,
};

export default withPageErrorHandler(CruxPageLayout);
